import { Form, Input } from 'antd';

import SearchGroupableArticle from './search-groupable-article';
import SelectedArticles from './selected-articles';
import ShareIdentificationPanel from './share-identification-panel';

/**
 * Madde grubu form field'larını render eden pure component.
 * @param {Object} props
 * @param {Object} props.form - Antd Form instance
 * @param {string} props.formId - Form HTML id'si (modal footer submit bağlantısı için)
 * @param {Function} props.onFinish - Form submit callback
 * @param {boolean} [props.readOnly=false] - true ise form alanları disabled, madde ekleme gizli
 * @param {boolean} [props.showSharePanel=false] - Kimlik kartı ortaklaştırma paneli gösterilsin mi
 * @param {boolean} [props.initialShareIdentification=false] - Grubun kayıtlı ortaklaştırma durumu; yeni grupta `false`
 * @param {Object|null} [props.sharedIdentificationCard=null] - Kurulu ortaklaştırmanın kartı; grup ortak değilse `null`
 */
function ArticleGroupFields({
  form,
  formId,
  onFinish,
  readOnly = false,
  showSharePanel = false,
  initialShareIdentification = false,
  sharedIdentificationCard = null,
}) {
  const members = Form.useWatch('members', form);
  const isSharing = Boolean(Form.useWatch('shareIdentification', form));
  const selectedArticleIds = (members ?? []).map((member) => member.id);
  // Telif Sonrası şartı yalnız kartı ortak grupta geçerli. Ortaklaştırma bu pencerede kapatılınca şart hemen kalkar:
  // BE de engeli istekte gelen `shareIdentification`'a göre uygular.
  const postOrderOnly = showSharePanel && initialShareIdentification && isSharing;

  const handleArticleSelect = (article) => {
    const currentMembers = form.getFieldValue('members') ?? [];
    const alreadyExists = currentMembers.some((m) => m.id === article.id);
    if (alreadyExists) return;

    form.setFieldsValue({
      members: [...currentMembers, { ...article, isMain: currentMembers.length === 0 }],
    });
  };

  return (
    <div className="gx-d-flex gx-flex-column" style={{ gap: '1rem' }}>
      <Form
        id={formId}
        form={form}
        onFinish={onFinish}
        layout="vertical"
        className="gx-d-flex gx-flex-column"
        style={{ gap: '0.75rem' }}
      >
        <Form.Item
          name="name"
          label="Grup Adı"
          rules={[{ required: true, message: 'Lütfen grup adını giriniz!' }]}
        >
          <Input placeholder="Grup adını giriniz" disabled={readOnly} />
        </Form.Item>

        {!readOnly && (
          <SearchGroupableArticle
            onSelect={handleArticleSelect}
            selectedArticleIds={selectedArticleIds}
            postOrderOnly={postOrderOnly}
          />
        )}

        {showSharePanel && (
          <ShareIdentificationPanel
            form={form}
            initialShareIdentification={initialShareIdentification}
            sharedIdentificationCard={sharedIdentificationCard}
          />
        )}

        <Form.List
          name="members"
          rules={[
            {
              validator: async (_, members) => {
                if (!members || members.length === 0) {
                  return Promise.reject(new Error('Lütfen en az bir madde seçiniz!'));
                }
              },
            },
          ]}
        >
          {(fields, operations, { errors }) => (
            <>
              <SelectedArticles
                fields={fields}
                operations={operations}
                form={form}
                readOnly={readOnly}
              />
              <Form.ErrorList errors={errors} />
            </>
          )}
        </Form.List>
      </Form>
    </div>
  );
}

export default ArticleGroupFields;
